export const SALES_GROUP_PERSON_PAGE_SIZE = 500;

export const getSalesPersonOptions = (results = []) =>
  (results || []).filter((channel) => channel?.sales_role === true);

export const getSalesManagerOptions = (results = []) =>
  (results || []).filter((channel) => channel?.sales_manager === true);

export const getFiPersonOptions = (results = []) =>
  (results || []).filter((channel) => channel?.fi_role === true);

export const findSalesGroupPersonName = (results = [], id) => {
  if (id === null || id === undefined || id === "") return "";
  const match = (results || []).find((person) => String(person.id) === String(id));
  return match?.name || String(id);
};
